import React, { PropTypes, Component } from 'react';
import EntitiesListHorizontolContainer from './EntitiesListHorizontolContainer';
import { connectToStores } from 'fluxible/addons';
import Rating from './Rating';
import { updateUserEntityOnFeedback, createUserCSV,createUserJSD, flushUserPreference, refreshUserEntity } from '../actions/WebsiteLoadCreator';
import UserSelection from './UserSelection';

var configs = require('../configs/configs.json');

var cookie = require('react-cookie');
var userLiked = [];
var userDisliked = [];
var clickCount = 0;

class Search extends Component {
  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }

  static contextTypes = {
    executeAction: React.PropTypes.func
  }

  tempSubmitData = {}

  constructor(props, context) {
    super(props, context);
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
    this.handleModalClose = this.handleModalClose.bind(this)
  }

  componentWillMount() {
    var temp = this.props.entities.userfavourite.filter(function(item, index) {
      return item.index < 30;
    });
    var length = 6;
    var data = temp.filter(function(item, index) {
      return item.index < length;
    });
    var state = 0;
    this.state = {
      data: data,
      select: state
    };
  }

  componentDidMount() {
    var inputs = this.props.entities.inputs;
    var self = this;
    $('#content').css('display', 'block');
    $('.draggable').draggable({
      revert: true,
      proxy: 'clone'
    });

    $('#myModal').on('show.bs.modal', function() {
      $('#myModal').on('hide.bs.modal', self.handleModalClose)  
    })
  }

  componentDidUpdate() {
    $(".whirly-loader").css('visibility', 'hidden');
  }

  isEntityLiked(likes, entity) {
    return likes[0] && (likes[0].indexOf(entity.id) != -1)
  }
  isEntityDisliked(dislikes, entity) {
    return dislikes[0] && (dislikes[0].indexOf(entity.id) != -1)
  }
  scrollDownAnimate() {
    $('.scroll-down-btn').hide()
    let secondRowElement = $('.droppable').slice(3)[0]
    if (secondRowElement) {
      $('html, body').animate({
        scrollTop: $(secondRowElement).offset().top - 110
      }, 1000);    
    }
  }
  render() {
    var userfavourite = this.state;
    userLiked.push(userfavourite.data && userfavourite.data[0] && userfavourite.data[0].likevector ? JSON.parse(userfavourite.data[0].likevector) : []);
    userDisliked.push(userfavourite.data && userfavourite.data[0] && userfavourite.data[0].dislikevector ? JSON.parse(userfavourite.data[0].dislikevector) : []);
    var userid = cookie.load('id', true);
    var userIdValid = configs.ValidUserIdForCSVGeneration.indexOf(userid) > -1 || true;
    return (
      <div>
        <UserSelection />
        <div id="content" style={ { 'overflow': 'hidden', 'padding': '2%', 'paddingTop': '2%' } }>
          <button className="heartBeat animated infinite delay-5s slow scroll-down-btn" onClick={this.scrollDownAnimate}><i className="fa fa-chevron-down"></i></button>
          <div className="row-fluid clearfix second-section">
            <div className="col-md-12 home-leftcontainer" style={ { "paddingLeft": "0px", "paddingRight": "0px" } }>
              <div className="main-entitycontainer" style={ { 'margin': '7em' } }>
                <div className="entity-container">
                  <div className="toprecommended">Top Recommendations for you</div>
                  <div className="entity-maincarousel" style={ { 'marginLeft': '2em' } }>
                    { /* userIdValid && <div className="row" style={{"margin": "0", "position": "relative", "left": "14px"}} onClick={this.downloadCSV.bind(this)}>
                        <div className="col-md-2 submit-btn match-btn" data-value="0">Download CSV</div>
                    </div> */ }
                    { /*userIdValid && <div className="row" style={{"margin": "0", "position": "relative", "left": "164px"}} onClick={this.downloadJSD.bind(this)}>
                        <div className="col-md-2 submit-btn match-btn" data-value="0">Download JSD</div>
                    </div>*/  }
                    { /* userIdValid && <div className="row" style={{"margin": "0", "position": "relative", "left": "324px", "bottom": "30px"}} onClick={this.clearUserPreference.bind(this)}>
                        <div className="col-md-2 submit-btn match-btn" data-value="0">Clear User Preferences.</div>
                    </div> */}
                    <ul className="col-md-12 entity_container item-padding" style={ { "marginLeft": "0em", "width": "100%" } }>
                      { userfavourite.data.map(function(entity, index) {
                          return (
                            <li className="col-xs-12 col-sm-6 col-md-4 col-lg-4 droppable" style={ { "marginBottom": "5%" } }>
				<div className="restaurant-card">
        <a className="entity-imagetab" href={entity.website_url} target="_blank">
				<div className="website-container searchwebsite-container" >
                                   <img className="website-outimage" src={ entity.image }/>
                                  <div className="entity-container-title searchentity-container-title">
                                    <div className="entity-container-titlename searchentity-container-titlename">
                                      { entity.title.replace(/&amp;/g, '&') }
                                    </div>
                                    <div className="entityaddress">
                                      { entity.address.replace(/(<([^>]+)>)/ig, "") }
                                    </div>
				    <div className="cuisines">
					{entity.cuisines}
				    </div>
                                    <p className={ "feedback-status status" + index }></p>
                                  </div>
                                </div>
                              </a>
				</div>
                            </li>
                            );
                        }.bind(this))}
                    </ul>
                  </div>
                  <div className="Entityborder"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div className="modal-dialog modal-sm" role="document" style={{width : '400px'}}>
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h3 className="modal-title" id="myModalLabel">Your chance to win £45!</h3>
                <h5 style={{marginBottom : 0}}> Please enter your details to participate in our prize draw </h5>
              </div>
              <div className="modal-body">
                <form id="userform">
                  <div className="form-group">
                    <label for="email">Email address</label>
                    <input type="email" className="form-control" id="email" placeholder="Email" required/>
                    <span>Email is required</span>
                  </div>
                  <div className="form-group">
                    <label for="name">Name</label>
                    <input type="text" className="form-control" id="name" placeholder="Name" required/>
                    <span>Name is required</span>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" onClick={this.handleFormSubmit} >Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }
handleFormSubmit(e) {
  e.preventDefault();
  if (!$('#userform')[0].checkValidity()) {
    $('form input:invalid').closest('.form-group').addClass('has-error')
    $('form input:invalid').on('blur', function(e) {
      if ($(e.target).get(0).checkValidity())
        $(e.target).removeClass('has-error')
    })
    return;
  }
  let submitData = {
    ...this.tempSubmitData,
    email : $('#email').val(),
    name : $('#name').val(),
  }
    $('#myModal').modal('hide')
  self.context.executeAction(updateUserEntityOnFeedback, submitData, function() {
	alert("Thank you for the details and feedback!");
  });
}
handleModalClose() {
  $('#myModal').off('hide.bs.modal')
  $('form input').closest('.form-group').removeClass('has-error')
  $('form input').off('blur')
  $('form input').val(null)
}
likeit(e, entity){
  e.preventDefault()
  if (this.isEntityDisliked(userDisliked, entity) || this.isEntityLiked(userLiked, entity))
    return;
    
    $(".whirly-loader").css('visibility', 'hidden');
    var index = Number(event.target.id);
    var inputs = this.props.entities.inputs;
    var self = this;
    var likeid,
      dislikeid,
      dislikedagainstid;
    var indextoreplacefrom = 3 + (Math.floor(self.state.data[index].index / 3) * 3);
    var likeiness = $(event.target).closest('.userfavourite-btn').data('likeiness');
    var idstoberepalced = self.props.entities.userfavourite.slice(0, indextoreplacefrom).map(function(x) {
      return x.id;
    });
    if (likeiness == 0) {
      // likeid = self.props.entities.userfavourite[self.state.data[index].index].id;
      likeid = entity.id
	     clickCount += 1;
    } else if (likeiness == 4 || likeiness == 3) {
      dislikedagainstid = inputs[index];
      // dislikeid = self.props.entities.userfavourite[self.state.data[index].index].id;
      dislikeid = entity.id
	     clickCount += 1;
    }
    if (likeid)
      userLiked[0].push(likeid);
    if (dislikeid)
      userDisliked[0].push(dislikeid);
    if ([0, 4, 3].indexOf(likeiness) > -1) {
      if ( clickCount >= 6 || this.state.data.length == clickCount) {
        this.tempSubmitData = {
          likeid: likeid,
          dislikeid: dislikeid,
          dislikedagainstid: dislikedagainstid,
          idstoberemoved: idstoberepalced,
          indextoreplacefrom: indextoreplacefrom,
          inputparams: inputs
        }
        $('#myModal').modal({
	  backdrop: 'static',
	  keyboard: false,
          show: true
	});
        
       // $('#myModal').modal('show')
        return;
      }
      setTimeout(function () {
        self.context.executeAction(updateUserEntityOnFeedback, {
          likeid: likeid,
          dislikeid: dislikeid,
          dislikedagainstid: dislikedagainstid,
          idstoberemoved: idstoberepalced,
          indextoreplacefrom: indextoreplacefrom,
          inputparams: inputs
        });
      })
    }
    self.context.executeAction(refreshUserEntity)
  }
  loadmorefavourite() {
   //  $('#0.heart,#1.heart,#2.heart').attr('src', 'https://s3-us-west-1.amazonaws.com/folink/icons/Heart.png');
    var entity = this.props.entities.userfavourite.filter(function(item, index) {
      return item.index < 18;
    });
    if (entity.length > this.state.data[0].index + 3) {
      var length = this.state.data[2].index;
      var data = entity.filter(function(item) {
        return item.index > length && item.index <= length + 3;
      });
      this.setState({
        data: data
      });
      $('#previous-btn').removeClass('disabled-btn');
    } else {
      $('#showmore-btn').addClass('disabled-btn');
    }
  }
  previousfavourite() {
   //  $('#0.heart,#1.heart,#2.heart').attr('src', 'https://s3-us-west-1.amazonaws.com/folink/icons/Heart.png');
    var entity = this.props.entities.userfavourite.filter(function(item, index) {
      return item.index < 18;
    });
    if ((entity.length > this.state.data[0].index) && (this.state.data[0].index > 0)) {
      var length = this.state.data[0].index;
      var data = entity.filter(function(item) {
        return item.index >= length - 3 && item.index < length;
      });
      this.setState({
        data: data
      });
      $('#showmore-btn').removeClass('disabled-btn');
    } else {
      $('#previous-btn').addClass('disabled-btn');
    }

  }
  userfavourite() {
    $('#fade').css('display', 'block');
  }
  downloadCSV() {
    $(".whirly-loader").css('visibility', 'visible');
    var inputs = this.props.entities.inputs;
    var data = {
        input: inputs,
        callback: function(str) {
            $(".whirly-loader").css('visibility', 'hidden');
            var a = document.createElement('a');
            var blob = new Blob([str], {'type': 'application\/octet-stream'});
            a.href = window.URL.createObjectURL(blob);
            a.download = 'export.csv';
            a.click();
        }
    };
    this.context.executeAction(createUserCSV, data);
  }
  downloadJSD() {
    $(".whirly-loader").css('visibility', 'visible');
    var inputs = this.props.entities.inputs;
    var data = {
        input: inputs,
        callback: function(str) {
            $(".whirly-loader").css('visibility', 'hidden');
            var a = document.createElement('a');
            var blob = new Blob([str], {'type': 'application\/octet-stream'});
            a.href = window.URL.createObjectURL(blob);
            a.download = 'JSD.csv';
            a.click();
        }
    };
    this.context.executeAction(createUserJSD, data);
  }
  clearUserPreference() {
    $(".whirly-loader").css('visibility', 'visible');
    var userid = cookie.load('id', true);
    var data = {
      userid: userid,
      callback: function() {
        $(".whirly-loader").css('visibility', 'hidden');
      }
    };
    this.context.executeAction(flushUserPreference, data);
  }
}
Search.defaultProps = {
  logindata: {}
};

Search = connectToStores(Search, ['LoginStore'], (stores, props) => {
  return {
    logindata: stores.LoginStore.get()
  };

});
module.exports = Search;



// WEBPACK FOOTER //
// ./src/components/Search.js